"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveProviderBindingCallback = resolveProviderBindingCallback;
function resolveProviderBindingCallback(params, binding) {
    return binding.provider(params.context);
}
//# sourceMappingURL=resolveProviderBindingCallback.js.map